/**
 * Serial write queue for adjacency-map persistence (WQ-340).
 *
 * Every persisting store action — and undo/redo — runs through `enqueue`, one at
 * a time, in call order. Without it, Ctrl+Z pressed while a delete is still in
 * flight diffs against server state that still holds the node, restores nothing
 * and consumes the history entry. Queued, the undo waits for the delete to land.
 * History snapshots are taken inside the queued job, so each one reflects every
 * earlier write.
 */

let tail: Promise<unknown> = Promise.resolve();

export function enqueue<T>(job: () => Promise<T>): Promise<T> {
  const run = tail.then(job, job);
  tail = run.catch(() => undefined);
  return run;
}
